// Very useful for printing when we are doing recursive pages. Depth is basically record idx
export const getSpaceId = (spaceId: string, printDepth?: number) =>
  `space-${spaceId}-${printDepth || 'stand'}`;

export const delay = (ms: number) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

export const roundTo10 = (num: number) => Math.ceil(num / 10) * 10;

export const safeNumber = (value: any, def: number) => {
  if (value === 0 || value === '0') return 0;
  const val = Number(value);

  return !isFinite(val) || val < 0 ? def : val;
};

export const mapPropertyToIdArray = (array: { id: string }[], idMap: { [key: string]: any }) => {
  return array.map((row: { id: string }) => idMap[row.id]).filter((value) => value !== undefined);
};

// @TODO apply the cell types from client
export const isAbsentCellValue = (cellValue: any) => {
  return cellValue === null || cellValue === undefined;
};
